// Tabs, made tabs (§8). The markup has every panel in the page, each under its title, which is
// how a page without script, a print and an agent read them; this turns a `.tabs` group into the
// tabs pattern — a tablist, one panel shown, arrow keys and Home/End between the tabs. Idempotent,
// so a host calls it after every render (the element does; the editor preview and static pages
// that draw the same markup call it themselves).
let seq = 0;

export function enhanceLayouts(root: ParentNode): void {
  root.querySelectorAll<HTMLElement>(".tabs[data-tabs]:not([data-live])").forEach((group) => {
    const list = group.querySelector<HTMLElement>(":scope > .tablist");
    const panels = [...group.querySelectorAll<HTMLElement>(":scope > .tab-panel")];
    const tabs = list ? [...list.querySelectorAll<HTMLButtonElement>("button[role=tab]")] : [];
    if (!list || !tabs.length || tabs.length !== panels.length) return;
    const n = ++seq;
    tabs.forEach((tab, i) => {
      const panel = panels[i];
      tab.id ||= `imd-tab-${n}-${i}`;
      panel.id ||= `imd-panel-${n}-${i}`;
      tab.setAttribute("aria-controls", panel.id);
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", tab.id);
      panel.tabIndex = 0;
    });
    const select = (i: number, focus: boolean) => {
      tabs.forEach((tab, j) => {
        const on = i === j;
        tab.setAttribute("aria-selected", String(on));
        tab.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    };
    list.addEventListener("click", (ev) => {
      const i = tabs.indexOf((ev.target as Element).closest("button[role=tab]") as HTMLButtonElement);
      if (i >= 0) select(i, false);
    });
    list.addEventListener("keydown", (ev) => {
      const i = tabs.indexOf(document.activeElement === null ? tabs[0] : ((ev.target as Element).closest("button[role=tab]") as HTMLButtonElement));
      const to = ev.key === "ArrowRight" ? (i + 1) % tabs.length : ev.key === "ArrowLeft" ? (i - 1 + tabs.length) % tabs.length : ev.key === "Home" ? 0 : ev.key === "End" ? tabs.length - 1 : -1;
      if (to < 0 || i < 0) return;
      ev.preventDefault();
      select(to, true);
    });
    list.hidden = false;
    group.setAttribute("data-live", "");
    select(Math.max(0, tabs.findIndex((t) => t.getAttribute("aria-selected") === "true")), false);
  });
}
